import { z } from 'zod'

import { schemas } from '~interface/zod-schema'

export type AssetType = z.infer<typeof schemas.AssetTypeEnum>
export const AssetTypeEnum = schemas.AssetTypeEnum
